import React, { ReactElement, useCallback, useEffect, useState } from 'react';
import './Chapters.scss';
import SideVolume from '../SideVolume/SideVolume';
import ChaptersItem from './ChaptersItem';
import { useAtom, useAtomValue } from 'jotai';
import { MyBooksAtom } from '../../../../store/MyBooksStore';
import { LoginStatus, LoginStatusAtom } from '../../../../store/AccountStore';
import { Product } from '../../../../Models/Product';
import {
    isTheChapterPurchased,
    isTheVolumePurchased,
    sortChapterItems,
    sortVolumeItems,
} from '../../../../utils/utils';
import { CartAtom } from '../../../../store/CartStore';
import { Cart } from '../../../../Models/Cart';
import SimulPubItem from '../SimulPub/SimulPubItem';

export enum TypesOfChapters {
    'Free_For_Limit',
    'Unlock',
    'Read',
    'Unlock_For_Free',
    'Read_For_Free',
    'Free',
    'In_Cart',
    'Not_For_Sale',
    'Undefined',
}

const temporaryPickChapterType = {
    0: TypesOfChapters.Read,
    1: TypesOfChapters.Unlock,
    2: TypesOfChapters.Unlock_For_Free,
    3: TypesOfChapters.Free_For_Limit,
    4: TypesOfChapters.Read_For_Free,
    5: TypesOfChapters.Free,
    6: TypesOfChapters.In_Cart,
    7: TypesOfChapters.Not_For_Sale,
    8: TypesOfChapters.Undefined,
};

interface Props {
    volumeNumber: number;
    chapters: any[];
    volumeId: number;
    withNewChapterAnnouncement?: string;
}

const VolumeChapterCreator = ({ volumeNumber, chapters, volumeId, withNewChapterAnnouncement }: Props): JSX.Element => {
        return <div className='series-chapter-side-container'>
            <SideVolume volumeNumber={volumeNumber} childAsRenderedProps={
                <>
                    {withNewChapterAnnouncement && <div className='series-chapter-new-chapter-announcement-wrapper'>
                        <span className='series-chapter-new-chapter-announcement-text'>New Chapter Expected On</span>
                        <span className='series-chapter-new-chapter-announcement-date'>{withNewChapterAnnouncement}</span>
                    </div>}
                    {chapters ? chapters?.map((chapter) => {
                            console.log('pricer', volumeNumber, chapter.chapterNumber, chapter?.readable.readingProgress * 100 / chapter?.readable.pageCount);
                            return <SimulPubItem isKodanshaPlus={false} chapter={chapter} showPublishDate/>;
                        }) :
                        <span className='series-chapter-side-no-chapters'>No Chapters</span>
                    }
                </>
            } />
        </div>;
    }
;

const Chapters = ({ products, sorted }): ReactElement => {
    return (
        <div className='series-chapter-container'>
            {(products as Product[])?.map((volume, index) => {
                // return VolumeChapterCreator(volume.volumeNumber, volume.chapters, volume.id, '');
                return <VolumeChapterCreator key={index} volumeId={volume.id}
                                             chapters={sortChapterItems(sorted, volume.chapters)}
                                             volumeNumber={volume.volumeNumber} />;
            })}
            {/*{VolumeChapterCreator(4, [11, 12, 13, 14, 15, 16])}*/}
            {/*{VolumeChapterCreator(3, [21, 22, 23, 24])}*/}
        </div>
    );
};

export default React.memo(Chapters);